exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-wrap .el-dragger,.upload-wrap .el-upload{width:100%}.upload-wrap .img-wrap{position:relative;width:100%;height:180px;line-height:180px;border:1px solid #c0ccda;border-radius:4px;text-align:center}.upload-wrap .img-wrap img{position:absolute;left:0;right:0;top:0;bottom:0;width:100%;height:100%;object-fit:cover}.upload-wrap .img-close{position:absolute;top:-7px;right:-7px;padding:0}.upload-tips{text-align:left!important;line-height:1;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-b9b655e4!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UploadItems/index.vue
// module id = 621
// module chunks = 0